import React, { useEffect, useMemo, useState } from 'react';
import CheckboxRow from '../shared/CheckboxRow';

// Modal checkbox picker for a list of { value, label } options (tags,
// sites). Uses MD3-styled checkboxes matching the TagsStep wizard.
// Works on a local draft: onApply(values) commits, onClose cancels,
// Esc or the overlay click cancels.
export default function OptionDialog({ title, options, selected, onApply, onClose }) {
  const all = options || [];
  const [values, setValues] = useState(selected || []);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const filtered = useMemo(() => {
    const q = filter.trim().toLowerCase();
    return q ? all.filter((o) => o.label.toLowerCase().includes(q)) : all;
  }, [all, filter]);

  const toggle = (value) =>
    setValues((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );

  return (
    <div
      className="dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div className="dialog dialog-options" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2 className="dialog-title">{title}</h2>
          <button type="button" className="dialog-close" onClick={onClose} title="Close">
            ×
          </button>
        </div>
        <div className="dialog-body">
          <input
            className="dialog-search"
            type="text"
            placeholder="Filter…"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <div className="dialog-count">
            {values.length} of {all.length} selected
          </div>
          <div className="dialog-list">
            {filtered.map((o) => (
              <CheckboxRow
                key={o.value}
                id={`option-${o.value}`}
                label={o.label}
                checked={values.includes(o.value)}
                onChange={() => toggle(o.value)}
              />
            ))}
            {filtered.length === 0 && <div className="dialog-empty">No options match</div>}
          </div>
        </div>
        <div className="dialog-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={() => onApply(values)}>
            Select
          </button>
        </div>
      </div>
    </div>
  );
}
